document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainImage || !thumbs.length) return;
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!thumb.dataset.imageSrc) return;
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.imageAlt || '';
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((productForm) => {
    const radios = Array.from(productForm.querySelectorAll('[data-variant-radio]'));
    const idInput = productForm.querySelector('input[name="id"]');
    const button = productForm.querySelector('[type="submit"]');
    const productSection = productForm.closest('[data-product-section]');
    if (!radios.length || !idInput) return;

    const updateVariant = (radio) => {
      idInput.value = radio.value;
      const available = radio.dataset.available === 'true';
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Sold out';
      }

      if (productSection) {
        const price = productSection.querySelector('.price');
        const current = productSection.querySelector('.price__current');
        let compare = productSection.querySelector('.price__compare');
        let saving = productSection.querySelector('.price__saving');

        if (current) current.textContent = radio.dataset.price || '';
        if (radio.dataset.comparePrice) {
          if (!compare && price) {
            compare = document.createElement('s');
            compare.className = 'price__compare';
            price.appendChild(compare);
          }
          compare.textContent = radio.dataset.comparePrice;
          compare.hidden = false;

          if (!saving && price) {
            saving = document.createElement('span');
            saving.className = 'price__saving';
            price.appendChild(saving);
          }
          saving.textContent = `Save ${radio.dataset.saving}%`;
          saving.hidden = false;
          price?.classList.add('price--sale');
        } else {
          if (compare) compare.hidden = true;
          if (saving) saving.hidden = true;
          price?.classList.remove('price--sale');
        }

        if (radio.dataset.mediaId) {
          productSection.querySelector(`[data-gallery-thumb][data-media-id="${radio.dataset.mediaId}"]`)?.click();
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    };

    radios.forEach((radio) => radio.addEventListener('change', () => updateVariant(radio)));
  });
});
